import React, { ReactElement } from "react";
import { Trans } from "react-i18next";
import { TranslationKeys } from "common/utils/i18n/fallbackEnTranslations";

export const PLACEHOLDER_MAPPINGS = {
  "{GET_HELP_LINK}": "getHelpLink",
  "{FLOODZONE_TEXT}": "floodzoneText",
  "{FIRM_NAME}": "firmName",
  "{MSC_LINK}": "mscLink",
  "{PROPERTY_LINK}": "propertyLink",
} as const;

export const transformPlaceholderMap = (map: {
  [key: string]: ReactElement;
}): { [key: string]: ReactElement } => {
  const transformedMap: { [key: string]: ReactElement } = {};

  Object.entries(map).forEach(([key, component]) => {
    transformedMap[
      PLACEHOLDER_MAPPINGS[key as keyof typeof PLACEHOLDER_MAPPINGS]
    ] = component;
  });

  return transformedMap;
};

const TranslatedFIRMWarningMessage = ({
  translationKey,
  placeholderToComponentMap,
}: {
  translationKey: TranslationKeys;
  placeholderToComponentMap: { [key: string]: ReactElement };
}) => {
  return (
    <Trans
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      i18nKey={translationKey as any}
      components={transformPlaceholderMap(placeholderToComponentMap)}
    />
  );
};

export default TranslatedFIRMWarningMessage;
